import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

export default function OpeningSlidePreview({ logo, backgroundColor }) {
  const { t } = useTranslation();
  const containerRef = useRef(null);
  const [scale, setScale] = useState(1);

  useEffect(() => {
    function updateScale() {
      if (!containerRef.current) return;
      const width = containerRef.current.getBoundingClientRect().width;
      setScale(width / 1920);
    }
    updateScale();
    window.addEventListener("resize", updateScale);
    return () => window.removeEventListener("resize", updateScale);
  }, []);

  return (
    <div
      ref={containerRef}
      className="w-full relative select-none"
      style={{
        aspectRatio: "16 / 9",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: 1920,
          height: 1080,
          transform: `scale(${scale})`,
          transformOrigin: "top left",
          backgroundColor: backgroundColor || "#000",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
        >
          {logo ? (
            <img
              src={logo}
              alt={t("logo preview")}
              className="max-h-full max-w-full object-contain mx-auto"
              style={{
                width: 200,
                height: 200,
              }}
            />
          ) : (
            <span className="text-4xl text-gray-400">{t("logo preview")}</span>
          )}
        </div>
      </div>
    </div>
  );
}
